export default "/images/b04c03c9dd40c08797bfc12e5f9457db.jpg";